import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { HIGHLIGHTS, scrollToSection } from './landingData';

const HERO_IMG = `${process.env.PUBLIC_URL}/images/landing/hero-education.svg`;

function HighlightChips() {
  return (
    <div className="flex flex-col gap-2.5">
      {HIGHLIGHTS.map((item) => {
        const Icon = item.icon;
        return (
          <div
            key={item.title}
            className="flex items-center gap-2.5 rounded-xl border border-white/10 bg-[#050816]/80 px-3 py-2 backdrop-blur-sm"
          >
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-blue-600/20">
              <Icon className="h-4 w-4 text-blue-400" />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-semibold text-white">{item.title}</p>
              <p className="text-[11px] text-white/50">{item.desc}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function LandingHero() {
  const navigate = useNavigate();

  return (
    <section className="mt-8 lg:mt-12">
      <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12">
        <div className="space-y-5">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/60">
            <Sparkles className="h-3.5 w-3.5 text-blue-400" />
            Premium ERP for modern institutions
          </div>

          <h1 className="text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl">
            A modern school ERP to manage{' '}
            <span className="text-sky-400">attendance</span>,{' '}
            <span className="text-sky-400">fees</span> &amp;{' '}
            <span className="text-sky-400">academics</span>.
          </h1>

          <p className="max-w-xl text-sm leading-relaxed text-white/60 sm:text-base">
            One dashboard for admins, with dedicated portals for teachers, students, and parents—timetable,
            homework, fees, attendance, and messaging. Simple, secure, and mobile-ready.
          </p>

          <div className="flex flex-wrap gap-3">
            <Button className="bg-blue-600 hover:bg-blue-700" onClick={() => navigate('/login')}>
              Login <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button
              variant="outline"
              className="border-white/20 bg-transparent text-white hover:bg-white/10"
              onClick={() => scrollToSection('features')}
            >
              Learn more
            </Button>
          </div>
        </div>

        <div className="relative flex items-center justify-center gap-3 lg:justify-end">
          <div className="pointer-events-none absolute inset-0 rounded-3xl bg-blue-500/10 blur-3xl" />
          <div className="pointer-events-none absolute -top-8 -left-8 h-24 w-24 rounded-2xl border border-white/10 bg-white/5 shadow-[0_20px_60px_rgba(0,0,0,0.35)] landing-float-slow" />
          <div className="pointer-events-none absolute -bottom-10 left-14 h-16 w-16 rounded-full border border-white/10 bg-blue-600/10 landing-float" />
          <img
            src={HERO_IMG}
            alt="Education and analytics illustration"
            className="relative w-full max-w-[220px] sm:max-w-xs lg:max-w-sm"
            loading="eager"
          />
          <div className="relative shrink-0">
            <HighlightChips />
          </div>
        </div>
      </div>
    </section>
  );
}
